import { Box } from '@material-ui/core';
// import { NextImageIcon, PrevImageIcon } from '@room-match/shared-ui-components'; //
import PrevImageIcon from '../Icon/PrevImageIcon'; // Use the talent app level folder Icon
import NextImageIcon from '../Icon/NextImageIcon'; // Use the talent app level folder Icon
import clsx from 'clsx';
import { ButtonBack, ButtonNext, CarouselProvider, Image, Slide, Slider } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import DecoratedComponent from './DecoratedComponent';
import './ImageCarousel.css';
import { useStyles } from './ImageCarousel.styles';

interface Props {
  images: any;
  thumbnails: any;
  current?: number;
}
const ImageCarousel = ({ images, thumbnails, current }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={125}
        totalSlides={images.length}
        visibleSlides={1}
        currentSlide={current || 0}
        isIntrinsicHeight={true}
        infinite={false}
      >
        <Slider>
          {images.map((image: any, i: number) => (
            <>
              <Slide index={i} classNameHidden={classes.imageHidden}>
                <Image hasMasterSpinner={true} style={{ borderRadius: '8', objectFit: 'contain' }} src={image.src} />
              </Slide>
            </>
          ))}
        </Slider>
        <ButtonBack className={clsx(classes.button, classes.buttonBack)}>
          <PrevImageIcon fontSize="small" />
        </ButtonBack>
        <ButtonNext className={clsx(classes.button, classes.buttonNext)}>
          <NextImageIcon fontSize="small" />
        </ButtonNext>
        <DecoratedComponent images={thumbnails} />
      </CarouselProvider>
      <Box className={classes.blurRight} />
      <Box className={classes.blurLeft} />
    </Box>
  );
};

export default ImageCarousel;
